import { initializeLinkListSlider } from '../../../_modules/slider/initialize_link_list_slider';

export const initializeSlider = () =>
    $('.link-list-slider')
        .toArray()
        .map(initializeLinkListSlider);
